<script>
  import Headline from './PrivacyPolicyHeadline.svelte'
  import Terms from './PrivacyPolicyTerm.svelte'
</script>

<svelte:head>
  <title>Política de Privacidade | Lutruvials</title>
</svelte:head>

<main class="mb-[128px] mt-[122px]">
  <Headline />
  <Terms />
</main>
